window.$ = window.jQuery;

export function handleStickyNav() {
    let $window = $(window);

    let windowWidth = $window.outerWidth();

    $(window).on("scroll", function () {
        updateStickyNav();

    }).on("resize", function () {
        let currentWidth = $window.outerWidth();

        if(windowWidth !== currentWidth){
            updateStickyNav();
        }

        windowWidth = currentWidth;
    });

    $(window).trigger("scroll");
}

export function updateStickyNav() {
    let scrollTop = $(window).scrollTop();

    if (scrollTop === 0) {
        $('body').removeClass('sticky-header');
        return;
    }

    if (scrollTop > $(".js-header").outerHeight()) {
        $('body').addClass('sticky-header');
    }
}
